<template>
  <div class="card-groups">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'card-groups'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.card-groups {
  &.-image-top-list {
    width: 100%;
    >.card-box {
      margin-bottom: 60px;
    }
    @include mq-up(){
      @include flex(flex,space-between,flex-start,row,wrap);
      >.card-box {
        width: 30%;
      }
    }
  }
}
.card-groups > .card-box {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/card/CardGroups.vue